import {
  GET_TEAM_CARD_DATA_REQUEST,
  GET_TEAM_CARD_DATA_SUCCESS,
  GET_TEAM_CARD_DATA_FAILURE,

  GET_TEAM_CARD_DATA_BY_SEASON_REQUEST,
  GET_TEAM_CARD_DATA_BY_SEASON_SUCCESS,
  GET_TEAM_CARD_DATA_BY_SEASON_FAILURE,

  RESET_TEAM_CARD_DATA
} from '../constants';

const initialState = {
  data: {},
  isLoading: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_TEAM_CARD_DATA_BY_SEASON_REQUEST:
    case GET_TEAM_CARD_DATA_REQUEST:
      return { ...state, isLoading: true, error: null };

    case GET_TEAM_CARD_DATA_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        error: null
      };

    case GET_TEAM_CARD_DATA_BY_SEASON_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload
        },
        isLoading: false,
        error: null
      };

        
    case RESET_TEAM_CARD_DATA:
      return initialState;
    
    case GET_TEAM_CARD_DATA_BY_SEASON_FAILURE:
    case GET_TEAM_CARD_DATA_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
       
     
};
